<main class="flex justify-center w-full min-h-screen bg-gray-100 p-6">

  <div class="bg-gray-100 flex flex-col justify-center" *ngIf="!isLoggedIn">
    <div class="bg-white px-20 py-16 rounded-md flex flex-col gap-3">
      <img src="/images/logo.svg" alt="" class="h-16 pointer-events-none select-none">
      <h1 class="text-2xl font-bold">Benvenuto in CTM</h1>
      <button class="button mt-6" (click)="loginRedirect()">Accedi
      </button>
    </div>
  </div>


  <div class="w-full" *ngIf="isLoggedIn">

    <div class="flex flex-col transition-all duration-300 ease-in-out gap-6" [ngClass]="{'lg:ml-64': menuOpen()}">

      <div class="flex relative h-12">
        <button (click)="toggleMenu('menu')"
                class="cursor-pointer focus:outline-none transition-opacity"
                [ngClass]="{'opacity-0': menuOpen()}"
        >
          <svg width="30" height="30" fill="none" viewBox="0 0 30 30" stroke="currentColor"
               xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>
        <img src="/images/logo.svg" alt="" class="absolute size-full pointer-events-none select-none">
      </div>

      <div class="pb-12">
        @if (currentPage() === 'form') {
          <app-request-form></app-request-form>
        } @else if (currentPage() === 'procedures' && !selectedItem()) {
          <app-procedures type='orders' (rowClicked)="onRowSelected($event)" (navigate)="onNavigate($event)"></app-procedures>
        }@else if (currentPage() === 'communications' && !selectedItem()) {
          <app-procedures type="communications" (rowClicked)="onRowSelected($event)" (navigate)="onNavigate($event)"></app-procedures>
        } @else if (currentPage() === 'my-requests' && !selectedItem()) {
          <app-my-requests (rowClicked)="onRowSelected($event)" (navigate)="onNavigate($event)"></app-my-requests>
        } @else if (currentPage() === 'ims-documents' && !selectedItem()) {
          <app-ims (rowClicked)="onRowSelected($event)" (navigate)="onNavigate($event)"></app-ims>
        } @else if (selectedItem() && selectedItem()?.type === 'request') {
          <app-request [item]="selectedItem()?.item" (goBackToMyRequests)="goBack()"></app-request>
        }  @else if (selectedItem() && selectedItem()?.type === 'procedure') {
          <app-procedure [item]="selectedItem()?.item" (goBackToProcedures)="goBack()"></app-procedure>
        } @else {
          <div>Page not Found</div>
        }
      </div>
    </div>

    <app-sidemenu [menuOpen]="menuOpen()" (navigate)="onNavigate($event)"></app-sidemenu>

  </div>

</main>

<router-outlet/>
